import _01_Email from './_01_Email';
import _02_Phone from './_02_Phone';
import _03_Profile from './_03_Profile';
import _04_Socials from './_04_Socials';

const index = {
  _01_Email,
  _02_Phone,
  _03_Profile,
  _04_Socials,
};

export default index;